<template>
  <div class="wrapper">
    <div class="outer">
      <div class="inner">
        <div class="wrap">
          <header>
            <h1 class="bi">
              {{ $t('lo001.brand') }}
            </h1>
            <div class="login-lang-switch">
              <button type="button" :class="{ active: $i18n.locale === 'ko' }" @click="changeLocale('ko')">
                KO
              </button>
              <button type="button" :class="{ active: $i18n.locale === 'en' }" @click="changeLocale('en')">
                EN
              </button>
            </div>
          </header>
          <main>
            <ul class="form">
              <li>
                <input type="text" v-model="userId" :placeholder="$t('lo001.idPlaceholder')" />
              </li>
              <li>
                <input type="password" v-model="userPw" :placeholder="$t('lo001.pwPlaceholder')" v-on:keyup.enter="loginBtn" />
              </li>
            </ul>
            <div class="save">
              <label>
                <input type="checkbox" v-model="staySignedIn" />
                <i></i>
                {{ $t('lo001.staySignedIn') }}
              </label>
            </div>
          </main>
          <footer>
            <div class="button">
              <!-- 비활성(Attribute) : disabled -->
              <button @click="loginBtn" :disabled="userId === '' || userPw === ''">
                {{ $t('lo001.login') }}
              </button>
            </div>
            <div class="forget">
              <div class="item">
                {{ $t('lo001.forgotPassword') }}
              </div>
            </div>
          </footer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import jwtDecode from 'jwt-decode'
import { setLocale } from '../i18n'

export default {
  data () {
    return {
      userId: '',
      userPw: '',
      staySignedIn: false
    }
  },
  computed: {
    loggingIn () {
      return this.$store.state.users.status.loggedIn
    }
  },
  created () {
    this.$store.dispatch('users/logout')
  },
  mounted () {
    if (navigator.userAgent.match(/iP(hone|od|ad)/)) {
      document.getElementsByName('viewport')[0].setAttribute('content', 'width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=0')
    } else {
      document.getElementsByName('viewport')[0].setAttribute('content', 'width=device-width, initial-scale=1.0')
    }
  },
  methods: {
    changeLocale (locale) {
      setLocale(locale)
    },
    loginBtn (e) {
      const { userId, userPw, staySignedIn } = this
      const { dispatch } = this.$store
      if (userId !== '' && userPw !== '') {
        if (userId && userPw) {
          dispatch('users/login', {userId, userPw, staySignedIn}).then(() => {
            const token = this.$store.state.users.user.data.token
            if (!window.apl) return false
            window.apl.loginSuccess(jwtDecode(token).accountId, token)
          })
        } else {
          alert(this.$t('lo001.enterIdPw'))
        }
      }
    }
  }
}
</script>

<style scoped>
.login-lang-switch {
  display: flex;
  justify-content: center;
  margin-top: 14px;
}
.login-lang-switch button {
  min-width: 38px;
  height: 26px;
  padding: 0 8px;
  border: 1px solid #d0d0d0;
  background: #fff;
  color: #888;
  font-size: 12px;
  line-height: 24px;
  cursor: pointer;
}
.login-lang-switch button:first-child {
  border-right: none;
  border-radius: 3px 0 0 3px;
}
.login-lang-switch button:last-child {
  border-radius: 0 3px 3px 0;
}
.login-lang-switch button.active {
  background: #333;
  border-color: #333;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/LO001.vue